import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { LozengeButton } from './MoreLozenge.tsx';
import messages from './messages.tsx';
import type { Props } from './types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyMoreLozenge = lazy(() =>
	import(
		/* webpackChunkName: "async-jira-software-releases-version-detail-related-work-more-lozenge" */ './MoreLozenge.tsx'
	).then((mod) => mod.MoreLozenge),
);

export const MoreLozengeAsync = (props: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { categories } = props;

	return (
		<Placeholder
			name="jira-software-releases-version-detail-related-work-more-lozenge"
			fallback={
				<LozengeButton isSelected={categories.some((category) => category.isSelected)}>
					{formatMessage(messages.moreButtonLabel, { count: categories.length })}
				</LozengeButton>
			}
		>
			<LazyMoreLozenge {...props} />
		</Placeholder>
	);
};
